import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useEffectOnce } from 'usehooks-ts';

import { companyUsersFetch } from './action';
import { selectFeatureUser } from './selector';

export const useCompanyUsersFetch = () => {
  const dispatch = useDispatch();
  const { companyUsers } = useSelector(selectFeatureUser);

  useEffectOnce(() => {
    if (!isEmpty(companyUsers)) return;
    dispatch(companyUsersFetch());
  });

  return companyUsers;
};
